(ns common.schema.entities.real-estate
  (:require
   [common.schema.entities.asset :as asset]
   [common.schema.entities.common :as common-schema]
   [common.schema.option-filters :as option-filters]
   [common.schema.schema-utils :as su]))

(def import-fixed-fields
  [:common/external-id
   :asset/name
   :real-estate/property-id])

(def schema
  (concat
   asset/schema
   [[:real-estate/property-id
     {:field/data-type             :data.type/text-simple
      :field/default-ord           1250
      :field/not-importable?       true
      :field/default-visibility    {:editor :editor.type/text-simple
                                    :grid   :editor.type/text-simple
                                    :filter :filter.type/text
                                    :field-visibility :not-in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations          {:en "Property ID"}
     }]
    [:real-estate/lot-number
     {:field/data-type             :data.type/text-simple
      :field/default-ord           1250
      :field/not-importable?       true
      :field/default-visibility    {:editor :editor.type/text-simple
                                    :grid   :editor.type/text-simple
                                    :filter :filter.type/text
                                    :field-visibility :not-in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations          {:en "Lot number"}
     }]

    [:real-estate/tenure
     {:field/data-type          :data.type/ref-single
      :field/default-ord        460
      :value-type               :entity
      :create-on-fly?           true
      :field/entity-types       [:entity.type/named-value]
      :named-value-attribute    :real-estate/tenure
      :field/default-visibility {:editor :editor.type/select
                                 :grid   :editor.type/select
                                 :filter :filter.type/select
                                 :field-visibility :in-use}
      :field/default-authorization {:access/read   :role/guest-sell-side
                                    :access/create :role/admin
                                    :access/write  :role/guest-sell-side}
      :field/translations       {:en "Tenure"}
     }]
    [:real-estate/usage
     {:field/data-type          :data.type/ref-single
      :field/default-ord        460
      :value-type               :entity
      :create-on-fly?           true
      :field/entity-types       [:entity.type/named-value]
      :named-value-attribute    :real-estate/usage
      :field/default-visibility {:editor :editor.type/select
                                 :grid   :editor.type/select
                                 :filter :filter.type/select
                                 :field-visibility :in-use}
      :field/default-authorization {:access/read   :role/guest-sell-side
                                    :access/create :role/admin
                                    :access/write  :role/guest-sell-side}
      :field/translations       {:en "Usage"}
     }]
    [:real-estate/type
     {:field/data-type          :data.type/ref-single
      :field/default-ord        460
      :value-type               :entity
      :create-on-fly?           true
      :field/entity-types       [:entity.type/named-value]
      :named-value-attribute    :real-estate/type
      :field/default-visibility {:editor :editor.type/select
                                 :grid   :editor.type/select
                                 :filter :filter.type/select
                                 :field-visibility :not-in-use}
      :field/default-authorization {:access/read   :role/guest-sell-side
                                    :access/create :role/admin
                                    :access/write  :role/guest-sell-side}
      :field/translations       {:en "Type"}
     }]
    [:real-estate/property-type
     {:field/data-type          :data.type/ref-single
      :field/default-ord        460
      :value-type               :entity
      :create-on-fly?           true
      :field/entity-types       [:entity.type/named-value]
      :named-value-attribute    :real-estate/property-type
      :field/default-visibility {:editor :editor.type/select
                                 :grid   :editor.type/select
                                 :filter :filter.type/select
                                 :field-visibility :in-use}
      :field/default-authorization {:access/read   :role/guest-sell-side
                                    :access/create :role/admin
                                    :access/write  :role/guest-sell-side}
      :field/translations       {:en "Property type"}
     }]
    [:real-estate/sourcing-method
     {:field/data-type          :data.type/ref-single
      :field/default-ord        460
      :value-type               :entity
      :create-on-fly?           true
      :field/entity-types       [:entity.type/named-value]
      :named-value-attribute    :real-estate/sourcing-method
      :field/default-visibility {:editor :editor.type/select
                                 :grid   :editor.type/select
                                 :filter :filter.type/select
                                 :field-visibility :not-in-use}
      :field/default-authorization {:access/read   :role/guest-sell-side
                                    :access/create :role/admin
                                    :access/write  :role/guest-sell-side}
      :field/translations       {:en "Sourcing method"}
     }]
    [:real-estate/type-of-heating
     {:field/data-type          :data.type/ref-multi
      :field/default-ord        460
      :value-type               :entity
      :create-on-fly?           true
      :field/entity-types       [:entity.type/named-value]
      :named-value-attribute    :real-estate/type-of-heating
      :field/default-visibility {:editor :editor.type/multi-select
                                 :grid   :editor.type/multi-select
                                 :filter :filter.type/select
                                 :field-visibility :not-in-use}
      :field/default-authorization {:access/read   :role/guest-sell-side
                                    :access/create :role/admin
                                    :access/write  :role/guest-sell-side}
      :field/translations       {:en "Type of heating"}
     }]
    [:real-estate/roof-material
     {:field/data-type          :data.type/ref-multi
      :field/default-ord        460
      :value-type               :entity
      :create-on-fly?           true
      :field/entity-types       [:entity.type/named-value]
      :named-value-attribute    :real-estate/roof-material
      :field/default-visibility {:editor :editor.type/multi-select
                                 :grid   :editor.type/multi-select
                                 :filter :filter.type/select
                                 :field-visibility :not-in-use}
      :field/default-authorization {:access/read   :role/guest-sell-side
                                    :access/create :role/admin
                                    :access/write  :role/guest-sell-side}
      :field/translations       {:en "Roof material"}}]
    [:real-estate/exterior-material
     {:field/data-type          :data.type/ref-multi
      :field/default-ord        460
      :value-type               :entity
      :create-on-fly?           true
      :field/entity-types       [:entity.type/named-value]
      :named-value-attribute    :real-estate/exterior-material
      :field/default-visibility {:editor :editor.type/multi-select
                                 :grid   :editor.type/multi-select
                                 :filter :filter.type/select
                                 :field-visibility :not-in-use}
      :field/default-authorization {:access/read   :role/guest-sell-side
                                    :access/create :role/admin
                                    :access/write  :role/guest-sell-side}
      :field/translations       {:en "Exterior material"}}]
    [:real-estate/frame-material
     {:field/data-type          :data.type/ref-multi
      :field/default-ord        460
      :value-type               :entity
      :create-on-fly?           true
      :field/entity-types       [:entity.type/named-value]
      :named-value-attribute    :real-estate/frame-material
      :field/default-visibility {:editor :editor.type/multi-select
                                 :grid   :editor.type/multi-select
                                 :filter :filter.type/select
                                 :field-visibility :not-in-use}
      :field/default-authorization {:access/read   :role/guest-sell-side
                                    :access/create :role/admin
                                    :access/write  :role/guest-sell-side}
      :field/translations       {:en "Frame material"}
     }]
    [:real-estate/local-energy-efficiency-class
     {:field/data-type          :data.type/ref-single
      :field/default-ord        460
      :value-type               :entity
      :create-on-fly?           true
      :field/entity-types       [:entity.type/named-value]
      :named-value-attribute    :real-estate/local-energy-efficiency-class
      :field/default-visibility {:editor :editor.type/select
                                 :grid   :editor.type/select
                                 :filter :filter.type/select
                                 :field-visibility :not-in-use}
      :field/default-authorization {:access/read   :role/guest-sell-side
                                    :access/create :role/admin
                                    :access/write  :role/guest-sell-side}
      :field/translations       {:en "Local energy efficiency class"}
     }]
    [:real-estate/energy-certification
     {:field/data-type          :data.type/ref-single
      :field/default-ord        460
      :value-type               :entity
      :create-on-fly?           true
      :field/entity-types       [:entity.type/named-value]
      :named-value-attribute    :real-estate/energy-certification
      :field/default-visibility {:editor :editor.type/select
                                 :grid   :editor.type/select
                                 :filter :filter.type/select
                                 :field-visibility :not-in-use}
      :field/default-authorization {:access/read   :role/guest-sell-side
                                    :access/create :role/admin
                                    :access/write  :role/guest-sell-side}
      :field/translations       {:en "Energy certification"}
     }]
    [:real-estate/capital-structure
     {:field/data-type             :data.type/text-simple
      :field/default-ord           1250
      :field/not-importable?       true
      :field/default-visibility    {:editor :editor.type/text-simple
                                    :grid   :editor.type/text-simple
                                    :filter :filter.type/text
                                    :field-visibility :not-in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations          {:en "Capital structure"}
     }]
    [:real-estate/rotation-policy
     {:field/data-type             :data.type/text-simple
      :field/default-ord           1250
      :field/not-importable?       true
      :field/default-visibility    {:editor :editor.type/text-simple
                                    :grid   :editor.type/text-simple
                                    :filter :filter.type/text
                                    :field-visibility :not-in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations          {:en "Rotation policy"}
     }]
    [:real-estate/conflict-of-interest
     {:field/data-type             :data.type/text-simple
      :field/default-ord           1250
      :field/not-importable?       true
      :field/default-visibility    {:editor :editor.type/text-simple
                                    :grid   :editor.type/text-simple
                                    :filter :filter.type/text
                                    :field-visibility :not-in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations          {:en "Conflict of interest"}
     }]
    [:real-estate/housing-company
     {:field/data-type             :data.type/text-simple
      :field/default-ord           1250
      :field/not-importable?       true
      :field/default-visibility    {:editor :editor.type/text-simple
                                    :grid   :editor.type/text-simple
                                    :filter :filter.type/text
                                    :field-visibility :not-in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations          {:en "Housing Company"}
     }]
    [:real-estate/holding-company
     {:field/data-type             :data.type/text-simple
      :field/default-ord           1250
      :field/not-importable?       true
      :field/default-visibility    {:editor :editor.type/text-simple
                                    :grid   :editor.type/text-simple
                                    :filter :filter.type/text
                                    :field-visibility :not-in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations          {:en "Holding Company"}
     }]
    [:real-estate/other-ownerships
     {:field/data-type             :data.type/text-simple
      :field/default-ord           1250
      :field/not-importable?       true
      :field/default-visibility    {:editor :editor.type/text-simple
                                    :grid   :editor.type/text-simple
                                    :filter :filter.type/text
                                    :field-visibility :not-in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations          {:en "Other ownerships"}
     }]
    [:real-estate/portfolio-name
     {:field/data-type             :data.type/text-simple
      :field/default-ord           1250
      :field/not-importable?       true
      :field/default-visibility    {:editor :editor.type/text-simple
                                    :grid   :editor.type/text-simple
                                    :filter :filter.type/text
                                    :field-visibility :not-in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations          {:en "Portfolio name"}
     }]
    [:real-estate/current-owner
     {:field/data-type             :data.type/text-simple
      :field/default-ord           1250
      :field/not-importable?       true
      :field/default-visibility    {:editor :editor.type/text-simple
                                    :grid   :editor.type/text-simple
                                    :filter :filter.type/text
                                    :field-visibility :in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations          {:en "Current owner"}
     }]

    [:real-estate/broker
     {:field/data-type             :data.type/text-simple
      :field/default-ord           1250
      :field/not-importable?       true
      :field/default-visibility    {:editor :editor.type/text-simple
                                    :grid   :editor.type/text-simple
                                    :filter :filter.type/text
                                    :field-visibility :in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations          {:en "Broker"}
     }]

    [:real-estate/financing
     {:field/data-type             :data.type/text-simple
      :field/default-ord           1250
      :field/not-importable?       true
      :field/default-visibility    {:editor :editor.type/text-simple
                                    :grid   :editor.type/text-simple
                                    :filter :filter.type/text
                                    :field-visibility :not-in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations          {:en "Financing"}
     }]
    [:real-estate/hedging
     {:field/data-type             :data.type/text-simple
      :field/default-ord           1250
      :field/not-importable?       true
      :field/default-visibility    {:editor :editor.type/text-simple
                                    :grid   :editor.type/text-simple
                                    :filter :filter.type/text
                                    :field-visibility :not-in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations          {:en "Hedging"}
     }]
    [:real-estate/tax-status
     {:field/data-type             :data.type/text-simple
      :field/default-ord           1250
      :field/not-importable?       true
      :field/default-visibility    {:editor :editor.type/text-simple
                                    :grid   :editor.type/text-simple
                                    :filter :filter.type/text
                                    :field-visibility :in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations          {:en "Tax status"}
     }]
    [:real-estate/initial-yield
     {:field/data-type          :data.type/percentage
      :field/default-visibility {:editor :editor.type/percentage
                                 :grid   :editor.type/percentage
                                 :filter :filter.type/percentage
                                 :field-visibility :in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations       {:en "Initial yield"}}]
    [:real-estate/current-yield
     {:field/data-type          :data.type/percentage
      :field/default-visibility {:editor :editor.type/percentage
                                 :grid   :editor.type/percentage
                                 :filter :filter.type/percentage
                                 :field-visibility :in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations       {:en "Current yield"}}]
    [:real-estate/reversionary-yield
     {:field/data-type          :data.type/percentage
      :field/default-visibility {:editor :editor.type/percentage
                                 :grid   :editor.type/percentage
                                 :filter :filter.type/percentage
                                 :field-visibility :in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations       {:en "Reversionary yield (forecast)"}}]
    [:real-estate/occupancy-rate
     {:field/data-type          :data.type/percentage
      :field/default-visibility {:editor :editor.type/percentage
                                 :grid   :editor.type/percentage
                                 :filter :filter.type/percentage
                                 :field-visibility :in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations       {:en "Occupancy rate"}}]
    [:real-estate/acquisition-yield
     {:field/data-type          :data.type/percentage
      :field/default-visibility {:editor :editor.type/percentage
                                 :grid   :editor.type/percentage
                                 :filter :filter.type/percentage
                                 :field-visibility :in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations       {:en "Acquisition yield"}}]]

   (su/currency-field :real-estate/cur-net-operating-income
                      "Net operating income"
                      {:authorization su/access-ssg-ssg
                       :default-field-visibility :not-in-use})

   (su/currency-field :real-estate/cur-capex-to-date
                      "Capex to date"
                      {:authorization su/access-ssg-ssg
                       :default-field-visibility :not-in-use})

   (su/currency-field :real-estate/cur-capex-projected
                      "Capex projected"
                      {:authorization su/access-ssg-ssg
                       :default-field-visibility :in-use})

   (su/currency-field :real-estate/cur-financing-costs
                      "Financing costs"
                      {:authorization su/access-ssg-ssg
                       :default-field-visibility :not-in-use})

   (su/currency-field :real-estate/cur-gross-vendor-income
                      "GRI (Gross vendor income)"
                      {:authorization su/access-ssg-ssg
                       :default-field-visibility :not-in-use})

   (su/currency-field :real-estate/cur-opex
                      "Opex (per annum)"
                      {:authorization su/access-ssg-ssg
                       :default-field-visibility :in-use})

   (su/currency-field :real-estate/cur-average-rent-psqm
                      "Average rent psqm"
                      {:authorization su/access-ssg-ssg
                       :default-field-visibility :not-in-use})

   (su/currency-field :real-estate/cur-average-opex-psqm
                      "Average opex psqm"
                      {:authorization su/access-ssg-ssg
                       :default-field-visibility :not-in-use})

   (su/currency-field :real-estate/cur-average-rent-psqf
                      "Average rent psqf"
                      {:authorization su/access-ssg-ssg
                       :default-field-visibility :not-in-use})

   (su/currency-field :real-estate/cur-average-opex-psqf
                      "Average opex psqf"
                      {:authorization su/access-ssg-ssg
                       :default-field-visibility :not-in-use})

   [[:real-estate/property-area
     {:field/data-type             :data.type/number
      :field/default-ord           720
      :field/constraints           {:constraint/smaller-than-inclusive 9007199254740991}
      :field/secondary-attribute-type :area-unit
      :field/default-visibility    {:editor :editor.type/number
                                    :grid   :editor.type/number
                                    :filter :filter.type/number
                                    :field-visibility :in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/custom-params         (fn [_]
                                     {:base-multiplier "1"})
      :field/translations          {:en "Property area"}
     }]
    [:real-estate/total-development-rights
     {:field/data-type             :data.type/number
      :field/default-ord           720
      :field/constraints           {:constraint/smaller-than-inclusive 9007199254740991}
      :field/secondary-attribute-type :area-unit
      :field/default-visibility    {:editor :editor.type/number
                                    :grid   :editor.type/number
                                    :filter :filter.type/number
                                    :field-visibility :in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/custom-params         (fn [_]
                                     {:base-multiplier "1"})
      :field/translations          {:en "Total development rights"}
     }]
    [:real-estate/used-development-rights
     {:field/data-type             :data.type/number
      :field/default-ord           720
      :field/constraints           {:constraint/smaller-than-inclusive 9007199254740991}
      :field/secondary-attribute-type :area-unit
      :field/default-visibility    {:editor :editor.type/number
                                    :grid   :editor.type/number
                                    :filter :filter.type/number
                                    :field-visibility :not-in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/custom-params         (fn [_]
                                     {:base-multiplier "1"})
      :field/translations          {:en "Used development rights"}
     }]
    [:real-estate/unused-development-rights
     {:field/data-type             :data.type/number
      :field/default-ord           720
      :field/constraints           {:constraint/smaller-than-inclusive 9007199254740991}
      :field/secondary-attribute-type :area-unit
      :field/default-visibility    {:editor :editor.type/number
                                    :grid   :editor.type/number
                                    :filter :filter.type/number
                                    :field-visibility :in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/custom-params         (fn [_]
                                     {:base-multiplier "1"})
      :field/translations          {:en "Unused development rights"}
     }]
    [:real-estate/lettable-area
     {:field/data-type             :data.type/number
      :field/default-ord           720
      :field/constraints           {:constraint/smaller-than-inclusive 9007199254740991}
      :field/secondary-attribute-type :area-unit
      :field/default-visibility    {:editor :editor.type/number
                                    :grid   :editor.type/number
                                    :filter :filter.type/number
                                    :field-visibility :in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/custom-params         (fn [_]
                                     {:base-multiplier "1"})
      :field/translations          {:en "Lettable area"}}]
    [:real-estate/number-of-parking-spaces-outdoor
     {:field/data-type             :data.type/integer
      :field/default-ord           20
      :field/constraints           {:constraint/number-positive        true
                                    :constraint/smaller-than-inclusive 9007199254740991}
      :field/default-visibility    {:editor :editor.type/integer
                                    :grid   :editor.type/integer
                                    :filter :filter.type/integer
                                    :field-visibility :not-in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations          {:en "Number of parking spaces outdoor"}
     }]
    [:real-estate/number-of-parking-spaces-indoor
     {:field/data-type             :data.type/integer
      :field/default-ord           20
      :field/constraints           {:constraint/number-positive        true
                                    :constraint/smaller-than-inclusive 9007199254740991}
      :field/default-visibility    {:editor :editor.type/integer
                                    :grid   :editor.type/integer
                                    :filter :filter.type/integer
                                    :field-visibility :not-in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations          {:en "Number of parking spaces indoor"}
     }]
    [:real-estate/additional-parking
     {:field/data-type          :data.type/text-multiline
      :field/default-ord        20
      :field/default-visibility {:editor :editor.type/text-simple
                                 :grid   :editor.type/text-simple
                                 :filter :filter.type/text
                                 :field-visibility :not-in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations       {:en "Parking other information"}
     }]
    [:real-estate/number-of-tenants
     {:field/data-type             :data.type/integer
      :field/default-ord           20
      :field/constraints           {:constraint/number-positive        true
                                    :constraint/smaller-than-inclusive 9007199254740991}
      :field/default-visibility    {:editor :editor.type/integer
                                    :grid   :editor.type/integer
                                    :filter :filter.type/integer
                                    :field-visibility :in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations          {:en "Number of tenants"}
     }]
    [:real-estate/percentage-let
     {:field/data-type          :data.type/percentage
      :field/default-visibility {:editor :editor.type/percentage
                                 :grid   :editor.type/percentage
                                 :filter :filter.type/percentage
                                 :field-visibility :in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations       {:en "Percentage let"}
     }]
    [:real-estate/number-of-buildings
     {:field/data-type             :data.type/integer
      :field/default-ord           20
      :field/constraints           {:constraint/number-positive        true
                                    :constraint/smaller-than-inclusive 9007199254740991}
      :field/default-visibility    {:editor :editor.type/integer
                                    :grid   :editor.type/integer
                                    :filter :filter.type/integer
                                    :field-visibility :in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations          {:en "Number of buildings"}
     }]
    [:real-estate/number-of-floors
     {:field/data-type             :data.type/integer
      :field/default-ord           20
      :field/constraints           {:constraint/number-positive        true
                                    :constraint/smaller-than-inclusive 9007199254740991}
      :field/default-visibility    {:editor :editor.type/integer
                                    :grid   :editor.type/integer
                                    :filter :filter.type/integer
                                    :field-visibility :in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations          {:en "Number of floors"}
     }]
    [:real-estate/number-of-floors-above-ground
     {:field/data-type             :data.type/integer
      :field/default-ord           20
      :field/constraints           {:constraint/number-positive        true
                                    :constraint/smaller-than-inclusive 9007199254740991}
      :field/default-visibility    {:editor :editor.type/integer
                                    :grid   :editor.type/integer
                                    :filter :filter.type/integer
                                    :field-visibility :not-in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations          {:en "Number of floors above ground"}
     }]
    [:real-estate/number-of-floors-below-ground
     {:field/data-type             :data.type/integer
      :field/default-ord           20
      :field/constraints           {:constraint/number-positive        true
                                    :constraint/smaller-than-inclusive 9007199254740991}
      :field/default-visibility    {:editor :editor.type/integer
                                    :grid   :editor.type/integer
                                    :filter :filter.type/integer
                                    :field-visibility :not-in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations          {:en "Number of floors below ground"}
     }]
    [:real-estate/number-of-lifts
     {:field/data-type             :data.type/integer
      :field/default-ord           20
      :field/constraints           {:constraint/number-positive        true
                                    :constraint/smaller-than-inclusive 9007199254740991}
      :field/default-visibility    {:editor :editor.type/integer
                                    :grid   :editor.type/integer
                                    :filter :filter.type/integer
                                    :field-visibility :not-in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations          {:en "Number of lifts"}
     }]

    [:real-estate/other-arrangements
     {:field/data-type          :data.type/text-multiline
      :field/default-ord        20
      :field/default-visibility {:editor :editor.type/text-simple
                                 :grid   :editor.type/text-simple
                                 :filter :filter.type/text
                                 :field-visibility :not-in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations       {:en "Other arrangements"}
     }]
    [:real-estate/refurbishments
     {:field/data-type          :data.type/text-multiline
      :field/default-ord        20
      :field/default-visibility {:editor :editor.type/text-simple
                                 :grid   :editor.type/text-simple
                                 :filter :filter.type/text
                                 :field-visibility :not-in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations       {:en "Refurbishments"}
     }]
    [:real-estate/construction-year
     {:field/data-type             :data.type/integer
      :field/default-ord           20
      :field/constraints           {:constraint/number-positive        true
                                    :constraint/smaller-than-inclusive 9007199254740991}
      :field/default-visibility    {:editor :editor.type/integer
                                    :grid   :editor.type/integer
                                    :filter :filter.type/integer
                                    :field-visibility :in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations          {:en "Construction year"}}]
    [:real-estate/construction-month
     {:field/data-type             :data.type/integer
      :field/default-ord           20
      :field/constraints           {:constraint/number-positive        true
                                    :constraint/smaller-than-inclusive 9007199254740991}
      :field/default-visibility    {:editor :editor.type/integer
                                    :grid   :editor.type/integer
                                    :filter :filter.type/integer
                                    :field-visibility :not-in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations          {:en "Construction month"}}]
    [:real-estate/construction-day
     {:field/data-type             :data.type/integer
      :field/default-ord           20
      :field/constraints           {:constraint/number-positive        true
                                    :constraint/smaller-than-inclusive 9007199254740991}
      :field/default-visibility    {:editor :editor.type/integer
                                    :grid   :editor.type/integer
                                    :filter :filter.type/integer
                                    :field-visibility :not-in-use}
      :field/default-authorization {:access/read  :role/guest-sell-side
                                    :access/write :role/guest-sell-side}
      :field/translations          {:en "Construction day"}}]
    common-schema/common-network-drive-field]
   common-schema/common-network-drives-field
   common-schema/common-folders-path
   (su/option-field-multi :real-estate/tag-tags
                          "Real estate tags"
                          {:authorization su/access-ssg-ssg
                           :default-field-visibility :in-use})
   (su/text-multiline-field :real-estate/deal
                            "Deal"
                            {:default-field-visibility :not-in-use
                             :authorization su/access-ssg-ssg})
   (su/text-multiline-field :real-estate/prop-company
                            "PropCo"
                            {:default-field-visibility :not-in-use
                             :authorization su/access-ssg-ssg})
   (su/text-multiline-field :real-estate/vendor
                            "Vendor"
                            {:default-field-visibility :not-in-use
                             :authorization su/access-ssg-ssg})
   (su/text-multiline-field :real-estate/city-plan-order
                            "City plan order"
                            {:default-field-visibility :not-in-use
                             :authorization su/access-ssg-ssg})
   (su/text-multiline-field :real-estate/facade-material
                            "Façade Material"
                            {:default-field-visibility :not-in-use
                             :authorization su/access-ssg-ssg})
   (su/text-multiline-field :real-estate/asset-management-partner
                            "Asset management partner"
                            {:default-field-visibility :not-in-use
                             :authorization su/access-ssg-ssg})
   (su/text-multiline-field :real-estate/rationale
                            "Rationale"
                            {:default-field-visibility :not-in-use
                             :authorization su/access-ssg-ssg})
   (su/text-multiline-field :real-estate/business-plan
                            "Business plan"
                            {:default-field-visibility :not-in-use
                             :authorization su/access-ssg-ssg})
   (su/text-multiline-field :real-estate/business-plan-status
                            "Business plan status"
                            {:default-field-visibility :not-in-use
                             :authorization su/access-ssg-ssg})
   (su/numeric-field :real-estate/site-area
                     "Site area"
                     {:default-field-visibility :not-in-use
                      :authorization su/access-ssg-ssg})
   (su/currency-symbol-field-not-secondary :real-estate/local-currency
                                           "Local currency"
                                           {:default-field-visibility :not-in-use
                                            :authorization su/access-ssg-ssg})
   (su/percentage-field :real-estate/ownership-percentage
                        "Ownership (%)"
                        {:default-field-visibility :not-in-use
                         :authorization su/access-ssg-ssg})
   (su/datetime-field :real-estate/acquisition-date
                      "Acquisition date"
                      {:default-field-visibility :not-in-use
                       :authorization su/access-ssg-ssg})
   (su/single-ref-field :real-estate/am-owner
                        "AM responsible"
                        [:entity.type/account]
                        {:authorization            su/access-ssg-ssg
                         :default-field-visibility :not-in-use
                         :option-filter-fn         option-filters/active-users
                         :os-filter-terms-fn       (fn [{:keys [] :as args}]
                                                     {"extras.active-user" true})
                         :not-clearable?           true})
   (su/text-simple-field :real-estate/am-owner-text
                         "AM owner"
                         {:authorization su/access-ssg-ssg
                          :default-field-visibility :not-in-use})

   (su/numeric-field :real-estate/total-area-sqm
                     "Total Area (sqm)"
                     {:authorization su/access-ssg-ssg
                      :default-field-visibility :not-in-use})
   (su/numeric-field :real-estate/net-lettable-area-sqm
                     "Net Lettable Area (sqm)"
                     {:authorization su/access-ssg-ssg
                      :default-field-visibility :not-in-use})
   (su/currency-field :real-estate/net-rental-income
                      "NRI (Net Rental Income)"
                      {:authorization su/access-ssg-ssg
                       :default-field-visibility :not-in-use})
   (su/currency-field :real-estate/target-nri
                      "Target NRI (Net Rental Income)"
                      {:authorization su/access-ssg-ssg
                       :default-field-visibility :not-in-use})
   (su/numeric-field :real-estate/walt-years
                     "WALT (years)"
                     {:authorization su/access-ssg-ssg
                      :default-field-visibility :not-in-use})
   (su/percentage-field :real-estate/vacancy-percentage
                        "Vacancy (%)"
                        {:authorization su/access-ssg-ssg
                         :default-field-visibility :not-in-use})
   (su/numeric-field :real-estate/average-rent-per-sqm
                     "Average Rent per sqm"
                     {:authorization su/access-ssg-ssg
                      :default-field-visibility :not-in-use})
   (su/currency-field :real-estate/purchase-price
                      "Purchase Price"
                      {:authorization su/access-ssg-ssg
                       :default-field-visibility :not-in-use})
   (su/numeric-field :real-estate/purchase-price-sqm
                     "Purchase Price (sqm)"
                     {:authorization su/access-ssg-ssg
                      :default-field-visibility :not-in-use})
   (su/multiplier-field :real-estate/purchase-multiple-nri
                        "Purchase Multiple (NRI)"
                        {:authorization su/access-ssg-ssg
                         :default-field-visibility :not-in-use})
   (su/percentage-field :real-estate/yield-percentage
                        "Yield (%)"
                        {:authorization su/access-ssg-ssg
                         :default-field-visibility :not-in-use})
   (su/currency-field :real-estate/capex-and-side-costs
                      "CapEx + Side Costs"
                      {:authorization su/access-ssg-ssg
                       :default-field-visibility :not-in-use})
   (su/currency-field :real-estate/all-in-cost
                      "All-in-Cost"
                      {:authorization su/access-ssg-ssg
                       :default-field-visibility :not-in-use})
   (su/currency-field :real-estate/exit-value
                      "Exit Value"
                      {:authorization su/access-ssg-ssg
                       :default-field-visibility :not-in-use})
   (su/multiplier-field :real-estate/levered-moic
                        "Levered MOIC (Multiple on Investment Capital)"
                        {:authorization su/access-ssg-ssg
                         :default-field-visibility :not-in-use})
   (su/percentage-field :real-estate/levered-irr
                        "Levered IRR (Internal Rate of Return)"
                        {:authorization su/access-ssg-ssg
                         :default-field-visibility :not-in-use})
   (su/percentage-field :real-estate/unlevered-irr
                        "Unlevered IRR (Internal Rate of Return)"
                        {:authorization su/access-ssg-ssg
                         :default-field-visibility :not-in-use})
   (su/percentage-field :real-estate/roi
                        "ROI (Return on Investment)"
                        {:authorization su/access-ssg-ssg
                         :default-field-visibility :not-in-use})
   (su/option-field :real-estate/sector
                    "Sector"
                    {:authorization su/access-ssg-ssg
                     :default-field-visibility :not-in-use})
   (su/currency-field :real-estate/cur-valuation-in-millions
                      "Valuation (in millions)"
                      {:authorization      su/access-ssg-ssg
                       :default-visibility :not-in-use})
   (su/currency-field :real-estate/cur-funding-requirement-in-millions
                      "Funding Requirement (in millions)"
                      {:authorization      su/access-ssg-ssg
                       :default-visibility :not-in-use})
   (su/text-multiline-field :real-estate/sector-details
                            "Sector Details"
                            {:authorization      su/access-ssg-ssg
                             :default-visibility :not-in-use})
   (su/currency-field :real-estate/cur-revenue-last-known
                      "Revenue (last known)"
                      {:authorization      su/access-ssg-ssg
                       :default-visibility :not-in-use})
   (su/currency-field :real-estate/cur-ebitda-last-known
                      "EBITDA (last known)"
                      {:authorization      su/access-ssg-ssg
                       :default-visibility :not-in-use})
   (su/currency-field :real-estate/cur-valuation
                      "Valuation"
                      {:authorization      su/access-ssg-ssg
                       :default-visibility :not-in-use})
   (su/currency-field :real-estate/cur-capital-sought
                      "Capital Sought"
                      {:authorization      su/access-ssg-ssg
                       :default-visibility :not-in-use})

   ;; leave this for easier merging
  ))
